import { useField } from 'formik';
import React, { FC, ReactNode } from 'react';
import FieldControl from '../field-control/field-control';
import FieldTextArea from '../field-textarea/field-textarea';

interface FormTextareaProps {
  readonly characterLimit?: number;
  readonly characterLimitLabel?: string;
  readonly help?: string;
  readonly label?: string;
  readonly labelColor?: string;
  readonly name: string;
  readonly placeholder?: string;
  readonly required?: boolean;
  readonly tooltipComponent?: ReactNode;
}

const FormTextarea: FC<FormTextareaProps> = ({
  characterLimit,
  characterLimitLabel,
  help,
  label,
  labelColor,
  name,
  placeholder,
  required,
  tooltipComponent,
}) => {
  const [field, meta, helpers] = useField(name);

  return (
    <FieldControl
      error={meta.touched && !!meta.error ? meta.error : null}
      help={help}
      label={label}
      labelColor={labelColor}
      required={required}
      tooltipComponent={tooltipComponent}
    >
      <FieldTextArea
        characterLimit={characterLimit}
        characterLimitLabel={characterLimitLabel}
        error={meta.touched && !!meta.error}
        onChange={(value) => helpers.setValue(value)}
        placeholder={placeholder}
        value={field.value}
      />
    </FieldControl>
  );
};

FormTextarea.defaultProps = {
  characterLimit: null,
  characterLimitLabel: null,
  help: null,
  label: null,
  labelColor: 'black',
  placeholder: null,
  required: false,
  tooltipComponent: null,
};

export default FormTextarea;
